import CMSPage from "@/components/CMSPage";
import { Calculator } from "lucide-react";

export default function ValuationPage() {
  return (
    <CMSPage
      pageId="valuation"
      defaultTitle="Free Property Valuation"
      defaultDescription="Book a free, no-obligation valuation from one of our expert local estate agents. Get an accurate assessment of your property's market value."
      icon={Calculator}
    />
  );
}
